/**
 * Centered section label between two hairlines that reach the column
 * edges (owner spec 2026-08-11): a step quieter than the old left-
 * aligned near-black labels. Caps and the display face come from the
 * global heading rule; the lines match the text's warm grey.
 */
export function SectionTitle({
  children, className = '',
}: { children: React.ReactNode; className?: string }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className="flex-1 h-px bg-[#D6D6CE]" />
      <h2 className="text-base leading-none text-[#A6A69E]">{children}</h2>
      <div className="flex-1 h-px bg-[#D6D6CE]" />
    </div>
  )
}
